<div class="proposalcardsdiv">
  <div class="card" *ngFor="let data of dataItems">
    <div class="card-overlay">
      <div class="overlay-icons">
        <span class="material-symbols-outlined" (click)="viewProposalCard(data)">
          visibility
        </span>
        <span class="material-symbols-outlined" (click)="downloadProposalCard(data)">
          download
        </span>
        <span class="material-symbols-outlined" (click)="editProposalCard(data)" *ngIf="isAuthorizedUser(data)">
          border_color
        </span>
        <span class="material-symbols-outlined" (click)="delProposalCard(data)">
          delete
        </span>
      </div>
    </div>

    <div class="card-header1">
      <div class="card-icondiv">
        <span class="material-symbols-outlined card-icon">
          {{ getSource(data.domain) }}
        </span>
      </div>
      <div class="card-productdiv">
        <span class="h5 fw-500 domain_name" title="{{data.domain}}">
          {{data.domain}}
        </span>
        <span class="h5 customerName">
          {{data.customerName}}
        </span>
      </div>

    </div>
    <div class="card-secondpart">
      <div class="card-year">
        <span *ngIf="!data.multiYear">Single Year</span>
        <span *ngIf="data.multiYear">Multi Year</span>
      </div>
      <div class="card-size">
        Size-{{getFirstLetter(data.size)}}
      </div>
      <div class="card-results">
          <span class="material-symbols-outlined wonicons won"
          [ngClass]="getStatusClass(doc.proposalStatus)"
          *ngIf="doc.proposalStatus === 'Won'">check</span> 
    <span class="material-symbols-outlined wonicons lost"
          [ngClass]="getStatusClass(doc.proposalStatus)"
          *ngIf="doc.proposalStatus === 'Lost'">close</span> 
    <span class="material-symbols-outlined wonicons inprogress"
          [ngClass]="getStatusClass(doc.proposalStatus)"
          *ngIf="doc.proposalStatus === 'In Progress'">progress_activity</span> 
    <span class="material-icons wonicons hold"
          [ngClass]="getStatusClass(doc.proposalStatus)"
          *ngIf="doc.proposalStatus === 'Hold'">pause</span> 
    <span class="material-icons wonicons nobid"
          [ngClass]="getStatusClass(doc.proposalStatus)"
          *ngIf="doc.proposalStatus === 'No Bid'">do_not_disturb</span>
        {{ data.proposalStatus }}
      </div>

    </div>
    <div class="card-techstackdetails row">
      <div class="card-techstackinnerdiv col-6">
        <div class="techstackicon">
          <span class="material-symbols-outlined personicon">
            contract
          </span>
        </div>
        <div class="techstackdiv">
          <span class="stacksheader">
            {{data.subServiceLine}}
          </span>
          <span class="stacksfooter">
            Service Line
          </span>
        </div>
      </div>
      <div class="card-techstackinnerdiv col-6">
        <div class="techstackicon">
          <span class="material-symbols-outlined personicon">
            contract
          </span>
        </div>
        <div class="techstackdiv">
          <span class="stacksheader">
            {{data.serviceType}}
          </span>
          <span class="stacksfooter">
            Service Type
          </span>
        </div>
      </div>

    </div>
    <div class="card-techstack">
      <div class="card-techstackinnerdiv">
        <div class="techstackicon">
          <span class="material-symbols-outlined personicon">
            person_2
          </span>
        </div>
        <div class="techstackdiv">
          <span class="stacksheader">
            {{getString(data.techStack)}}
          </span>
          <span class="stacksfooter">
            Techstack
          </span>
        </div>
      </div>

    </div>
    <div class="row">
      <div class="card-techstackinnerdiv col-6">
        <div class="techstackicon">
          <span class="material-symbols-outlined personicon">
            person_2
          </span>
        </div>
        <div class="techstackdiv">
          <span class="stacksheader">
            {{data.serviceLine}}
          </span>
          <span class="stacksfooter">
            Competency
          </span>
        </div>
      </div>
      <div class="card-techstackinnerdiv col-6">
        <div class="techstackicon">
          <span class="material-symbols-outlined personicon">
            description
          </span>
        </div>
        <div class="techstackdiv">
          <span class="stacksheader">
            {{data.artefactsCount}} Documents
          </span>
          <span class="stacksfooter">
            Artefacts
          </span>
        </div>
      </div>

    </div>
    <div class="card-techstackdetails row">
      <div class="card-techstackinnerdiv col-6">
        <div class="techstackicon">
          <span class="material-symbols-outlined personicon">
            calendar_month
          </span>
        </div>
        <div class="techstackdiv">
          <span class="stacksheader">
            {{data.createdOn | date:'shortDate'}}
          </span>
          <span class="stacksfooter">
            Created Date
          </span>
        </div>
      </div>
      <div class="card-techstackinnerdiv col-6">
        <div class="techstackicon">
          <span class="material-symbols-outlined personicon">
            calendar_month
          </span>
        </div>
        <div class="techstackdiv">
          <span class="stacksheader">
            {{data.createdBy}}
          </span>
          <span class="stacksfooter">
            Created by
          </span>
        </div>
      </div>
    </div>
    <div class="techcard-footer">
      <div class="footerdetails">
        <span class="stacksfooter">
          Service Offered:
        </span>
        <span class="stacksheader" title="{{data.servicesOffering}}">
          {{getString(data.servicesOffering)}}
        </span>
      </div>
    </div>
  </div>
</div>